import React from 'react'
import { Icon, IconProps } from '@chakra-ui/react'

const WhatsappIconColor = (props: IconProps) => {
  return (
    <Icon
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="currentcolor"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 31C23.732 31 30 24.732 30 17C30 9.26801 23.732 3 16 3C8.26801 3 2 9.26801 2 17C2 19.5109 2.661 21.8674 3.81847 23.905L2 31L9.31486 29.3038C11.3014 30.3854 13.5789 31 16 31ZM16 28.8462C22.5425 28.8462 27.8462 23.5425 27.8462 17C27.8462 10.4576 22.5425 5.15385 16 5.15385C9.45755 5.15385 4.15385 10.4576 4.15385 17C4.15385 19.5261 4.9445 21.8675 6.29184 23.7902L5.23077 27.7692L9.27993 26.7569C11.1894 28.0746 13.5046 28.8462 16 28.8462Z"
        fill="#BFC8D0"
      />
      <path
        d="M28 16C28 22.6274 22.6274 28 16 28C13.4722 28 11.1269 27.2184 9.19266 25.8837L5.09091 26.9091L6.16576 22.8784C4.80092 20.9307 4 18.5589 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z"
        fill="url(#paint0_linear_5166_41611)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 18.5109 2.661 20.8674 3.81847 22.905L2 30L9.31486 28.3038C11.3014 29.3854 13.5789 30 16 30ZM16 27.8462C22.5425 27.8462 27.8462 22.5425 27.8462 16C27.8462 9.45755 22.5425 4.15385 16 4.15385C9.45755 4.15385 4.15385 9.45755 4.15385 16C4.15385 18.5261 4.9445 20.8675 6.29184 22.7902L5.23077 26.7692L9.27993 25.7569C11.1894 27.0746 13.5046 27.8462 16 27.8462Z"
        fill="white"
      />
      <path
        d="M12.5 9.50038C12.1672 8.8318 11.6565 8.89099 11.1407 8.89099C10.2188 8.89099 8.78125 9.99527 8.78125 12.0504C8.78125 13.7348 9.52345 15.5785 12.0244 18.3366C14.438 20.9984 17.6094 22.3753 20.2422 22.3284C22.875 22.2816 23.4167 20.0159 23.4167 19.2508C23.4167 18.9117 23.2062 18.7425 23.0613 18.6965C22.1641 18.2659 20.5093 17.4636 20.1328 17.3129C19.7563 17.1622 19.5597 17.366 19.4375 17.477C19.0961 17.8023 18.4193 18.7613 18.1875 18.977C17.9558 19.1926 17.6103 19.0835 17.4665 19.0019C16.9374 18.7896 15.5029 18.1516 14.3595 17.0431C12.9453 15.6723 12.8623 15.2006 12.5959 14.7808C12.3828 14.4449 12.5392 14.2389 12.6172 14.1488C12.9219 13.7973 13.3426 13.2545 13.5313 12.9848C13.7199 12.715 13.5702 12.3055 13.4803 12.0504C13.0938 10.9535 12.7663 10.0352 12.5 9.50038Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5166_41611"
          x1="26.5"
          y1="7"
          x2="4"
          y2="28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5BD066" />
          <stop offset="1" stopColor="#27B43E" />
        </linearGradient>
      </defs>
    </Icon>
  )
}

export default WhatsappIconColor
